export default __webpack_public_path__ + "static/media/sensotrend_signin_login_complete.e0b235b5.png";